
import { useState } from 'react';
import '../App.scss';
import { Container, Row } from 'react-bootstrap';

function DataProtectionAddendum() {

  return (
    <main>
      <Container className="py-6 py-sm-8">
        <h1 className="pb-4">Our Data Protection Addendum</h1>
        <Row className="align-items-center mb-6">
          <iframe
          title="PDF Viewer"
          width="100%"
          height="1000px"
          src="/DataProtectionAddendum.pdf"
      ></iframe>
        </Row>
      </Container>

    </main>
  );
}

export default DataProtectionAddendum;